<template>
	<section>
		<!-- Clinic Profile -->
		<section class="single-doc section_pad">
			<div class="row">

				<!-- Clinic Item Wrap -->
				<div class="single-clinic__item-wrap">

					<!-- Clinic Item -->
					<div class="box clear_fix hr">

						<div class="columns small-12 medium-4 large-3">
							<div class="box__avatar-wrap">
								<img src="../../assets/img/clinic_avatar.png" class="box__avatar box__avatar_clinic-item_single">
							</div>
						</div>

						<div class="columns small-12 medium-8 large-9">

							<div class="box__content box__content_single box__stars">
								<h4 class="box__title box__title_clinic-item underline">{{clinic.name}}</h4>
								<div class="box__labels-wrap">
									<span class="box__label">{{clinic.clinic_type_name || 'Медицинский центр'}}</span>
								</div>
								<p class="box__paragraph bold">{{clinic.own_type | type}}</p>
								<p class="box__paragraph" v-html="clinic.description"></p>

								<rating :stars="clinic.mark" :review-count="clinic.mark_count"></rating>
							</div>
						</div>
						<!-- Column End -->

					</div>
					<!-- Clinic Item End -->

				</div>
				<!-- Clinic Item Wrap End -->
			</div>

			<div class="row">

				<div class="columns small-12 medium-12 large-8 end">

					<!-- Clinic Adress -->
					<div class="box flex clear_fix hr">

						<div class="box__content box__content_clinic">
							<p class="box__paragraph" v-if="clinic.city !== undefined">
								{{clinic.city.region.country.name}} {{clinic.city.region.name}}, {{clinic.city.name}}, ул. {{clinic.street}}, {{clinic.house}}
							</p>
							<p class="box__paragraph">{{clinic.contact}}</p>
						</div>

						<div class="box-message">
							<!--<div class="box-message__item">Записть по телефону со страницы клинки.</div>-->
						</div>
					</div>
					<!-- Clinic Adress End -->
				</div>
				<!-- Column End -->

			</div>
			<!-- Row End -->
		</section>
		<!-- Clinic Profile End -->

		<!-- Map -->
		<div id="map" class="map"></div>
		<!-- Map END -->

		<!-- Review -->
		<section class="review-section">
			<div class="row">

				<div class="columns small-12 medium-12 large-12">
					<div class="basic-btn review-section__btn">
						<button v-if="!isEditor && logged" @click="openEditor" class="basic-btn__item basic-btn__item_review">Оставить отзыв</button>
					</div>
				</div>

				<div class="columns small-12 medium-12 large-12">
					<div class="row">
						<editor v-if="isEditor" @close="closeEditor" whom="clinic" :subject="clinic"></editor>
					</div>
					<!--Row End-->
				</div>
				<!--Column End-->

				<div class="reviews-box" v-if="reviews.length">
					<h4 class="reviews-box__title">
						Отзывы о клинике "{{clinic.name}}"
					</h4>

					 <!--Review Item -->
					<review :value="review" v-for="review in reviews" :key="review._id" whom="clinic" :subject="clinic"
									@update="getReviews(clinicID)"></review>
					 <!--Review Item End -->

				</div>
				<!--Reviews Box End-->

			</div>
			<!--Row End-->

		</section>
		<!-- Review End -->

		<!--Clinic Docs Main Wrap-->
		<section class="clinic-doctors-main-wrap section_pad">
			<h2 class="section-title">Список врачей</h2>
			<!-- Doc Item Wrap -->
			<div class="clinic-doctors">

				<!-- Doc Item -->
				<div class="box clinic-doctors__box flex clear_fix hr main-border" v-for="work in doctors">

					<div class="box__avatar-wrap">
						<router-link :to="{name: 'SingleDoctor', query: {id: work.user_id}}" class="box__link">
							<user-avatar :data="work.user" :setClass="'box__avatar_doc-item user_fix'"></user-avatar>
						</router-link>
					</div>

					<div class="box__content box__stars">
						<h4 class="box__title box__title_doc-item underline">
							<router-link class="" :to="{name: 'SingleDoctor', query: {id: work.user_id}}">
								{{work.user_last_name}} {{work.user_first_name}} {{work.user_middle_name}}
							</router-link>
						</h4>

						<p class="box__labels-wrap">
							<span class="box__label" v-for="item in work.user_specializations">{{item.name}}</span>
						</p>

						<div class="box__purpose-wrap" v-if="work.user.doctor_type !== undefined">
							<span class="box__purpose-item" v-show="work.user.doctor_type.indexOf('childish') != -1">Детский</span>
							<span class="box__purpose-item" v-show="work.user.doctor_type.indexOf('adult') != -1">Взрослый</span>
						</div>

						<p class="box__paragraph bold">
							{{work.user_category}} {{work.user_degree}} {{work.user_experience}}
						</p>

						<create-visit-button :work="work" :appointment="appointment" class="box__btn_center single-btn"></create-visit-button>

						<rating :stars="work.user.mark" :review-count="work.user.mark_count"></rating>
					</div>

				</div>
				<!-- Doc Item End -->
			</div>
			<!-- Doc Item Wrap End -->

			<pagination :options="paginationOptions" @trigger="loadPage"></pagination>

		</section>
		<!--Clinic Docs Main Wrap End-->

		<appointment></appointment>
	</section>
</template>

<script>
	import Map from '../../common/Map';
	import Appointment from '../../components/Modals/Appointment.vue';
	import Pagination from '../../components/Pagination.vue'
	import Rating from '../../components/Stars/Rating.vue';
	import Review from '../../components/Reviews/Review.vue';
	import Editor from '../../components/Reviews/Editor.vue';
	import CreateVisitButton from '../../components/CreateVisitButton.vue';

	export default {
		name: "SingleClinic",
		components: {Appointment, Rating, Pagination, Review, Editor, CreateVisitButton},
		computed: {
			clinicID() {
				return this.$route.query.id
			},
			logged() {
				return this.$store.state.auth.logged
			}
		},
		mounted() {
			this.getClinic(this.clinicID);
			this.getWorkersByClinic();
			this.getReviews(this.clinicID);
		},
		data(){
			return {
				doctors: [],
				clinic: {},
				reviews: [],
				paginationOptions: {
					current: 1,
					total: 1
				},
				isEditor: false
				
			}
		},
		methods: {
			getClinic(id) {
				this.$store.dispatch('clinic/get', id).then(clinic => {
					return this.clinic = clinic;
				}).then(clinic => {
					new Map({
						$el: '#map',
						center: {
							lat: +clinic.latitude,
							lng: +clinic.longitude
						},
						zoom: 13
					}).$addMarker({
						lat: +clinic.latitude,
						lng: +clinic.longitude
					});
				});
			},
			getWorkersByClinic() {
				this.$store.dispatch('worker/list', {
					clinic_id: this.$route.query.id,
					current_page: this.paginationOptions.current
				})
					.then(result => {
						this.paginationOptions.total = result.last_page;
						this.paginationOptions.current = result.current_page;
						this.doctors = result.data;
						this.doctors = this.doctors.filter(doc => doc.role_type == 'doctor' || doc.role_type == 'doctor_admin');
					})
			},
			appointment(work) {
				this.$event.send('openAppointment', work);
			},
			getReviews(id) {
				this.$store.dispatch('review/list', {id: id, obj_type: 'clinic'})
					.then(list => this.reviews = list);
			},
			loadPage(page) {
				this.paginationOptions.current = page;
				this.getWorkersByClinic();
			},
			openEditor() {
				this.isEditor = true;
			},
			closeEditor() {
				this.isEditor = false;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// SingleClinic.vue?115d9444